import { FormikProvider, useField, useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Button, Paragraph, Separator, Switch, Title } from '@treams/treams-ui';

import BareLayout from '../../../../../../src/packages/kakapo-ui-application/layouts/BareLayout';
import PublicForm from '../../components/authentication/PublicForm';

function CookieWarningConsent() {
	const { t } = useTranslation();
	const [{ value }, , { setValue }] = useField<boolean>('consent');

	return (
		<Switch
			on={value}
			onChange={() => setValue(!value)}
			label={t('privacyConsent.allowUsageStatistics')}
		/>
	);
}

export default function PrivacyConsent() {
	const { t } = useTranslation();
	const { language } = useLocalize();

	const formik = useFormik({
		initialValues: {
			consent: false,
		},
		onSubmit: () => {},
	});

	const [update, { loading }] = graphql.useUpdatePrivacyConsentMutation({
		variables: {
			input: {
				allowsUsageStatistics: formik.values.consent,
				version: '1.5',
			},
		},
	});

	const descriptions = t('privacyConsent.description').split('<br />');

	return (
		<BareLayout>
			<FormikProvider value={formik}>
				<PublicForm empty>
					<Title>{t('privacyConsent.title')}</Title>
					<Separator mt={2} />
					{/* <Box my={3}>{language.id === 'nl_NL' ? <PrivacyConsentNL /> : <PrivacyConsentEN />}</Box> */}
					<Paragraph my={3}>
						{descriptions.map((text, index) => (
							<>
								{text}
								{index !== descriptions.length - 1 && <br />}
							</>
						))}{' '}
						<a
							href={`https://terms.ontreams.com/Treams+App+-+Privacy+statement+Treams+B.V.+2021+v1.5+(${
								language.id === 'nl_NL' ? 'NL' : 'EN'
							}).pdf`}
							target="_blank"
							rel="noreferrer"
						>
							{t('privacyConsent.policies.privacy.title')}
						</a>{' '}
						&amp;{' '}
						<a
							href={`https://terms.ontreams.com/Treams+App+-+Cookie+policy+v1.5+(${
								language.id === 'nl_NL' ? 'NL' : 'EN'
							}).pdf`}
							target="_blank"
							rel="noreferrer"
						>
							{t('privacyConsent.policies.cookies.title')}
						</a>
						.
					</Paragraph>
					<Separator />
					<Box my={3}>
						<CookieWarningConsent />
					</Box>
					<Flex justifyContent="flex-end" alignItems="cenfleter" mt={3} mb={0}>
						<Box flexShrink={0} flexGrow={0} ml={4}>
							<Button
								loading={loading}
								onClick={async () => {
									await update();
								}}
								title={t('privacyConsent.accept')}
							/>
						</Box>
					</Flex>
				</PublicForm>
			</FormikProvider>
		</BareLayout>
	);
}
